import {createSelector} from "reselect";
import {
  ServiceTypeFreightTypeAssoc,
  ServiceTypeFreightTypeAssocEntity
} from "../../../model/service-type-freight-type-assoc";
import {getUseQueryResultData} from "../../../util/selector-util";
import {firstOrUndefined} from "../../../util/util";

export interface ServiceTypeFreightTypeAssocSelectorProps {

}

export const serviceTypeFreightTypeAssocsSelector = () => createSelector(
  [getUseQueryResultData<ServiceTypeFreightTypeAssoc[]>],
  (data) => {
    return selectServiceTypeFreightTypeAssocsAndTransform(
      data ?? [],
      {}
    );
  }
);

export const serviceTypeFreightTypeAssocSelector = () => createSelector(
  [getUseQueryResultData<ServiceTypeFreightTypeAssoc>],
  (data) => {
    return data ? transformServiceTypeFreightTypeAssoc(data) : undefined;
  }
);

export const preferredFreightTypeIdSelector = () => createSelector(
  [getUseQueryResultData<ServiceTypeFreightTypeAssoc[]>],
  (data) => {
    const assocs = selectServiceTypeFreightTypeAssocsAndTransform(data ?? [], {});
    const sortedAssocs = assocs?.sort((a, b) => {
      return a.preferenceRank - b.preferenceRank
    });
    return firstOrUndefined(sortedAssocs)?.freightTypeId;
  }
);

export const selectServiceTypeFreightTypeAssocs = (values?: ServiceTypeFreightTypeAssoc[], selector?: ServiceTypeFreightTypeAssocSelectorProps): ServiceTypeFreightTypeAssoc[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;
    return filterIn;
  });
};

export const transformServiceTypeFreightTypeAssoc = (value: ServiceTypeFreightTypeAssoc): ServiceTypeFreightTypeAssocEntity => {
  return ServiceTypeFreightTypeAssocEntity.from(value)
}

export const selectServiceTypeFreightTypeAssocsAndTransform = (values?: ServiceTypeFreightTypeAssoc[], selector?: ServiceTypeFreightTypeAssocSelectorProps): ServiceTypeFreightTypeAssocEntity[] => {
  const selected = selectServiceTypeFreightTypeAssocs(values, selector);
  return selected.map(transformServiceTypeFreightTypeAssoc);
};
